export default {
  markAllAsRead: 'Mark all as read',
  showOnlyUnread: 'Show only unread',
  seeAll: 'See all',
};
